import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import type { Project } from '@/types/diagram';

interface ProjectCardProps {
  project: Project;
  onDelete: (id: string) => void;
}

function timeAgo(ts: number): string {
  const diff = Math.floor((Date.now() - ts) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function ProjectCard({ project, onDelete }: ProjectCardProps) {
  const nodeCount = project.diagram.nodes.length;
  const edgeCount = project.diagram.edges.length;

  return (
    <div className="group rounded-clyra-lg border border-line-default bg-clyra-raised p-4 transition-all duration-150 hover:border-line-strong hover:shadow-clyra-sm">
      <div className="flex items-start justify-between">
        <Link to={`/editor/${project.id}`} className="min-w-0 flex-1">
          <h3 className="truncate text-sm font-medium text-ink-primary group-hover:text-brand-400 transition-colors">
            {project.name}
          </h3>
          <p className="mt-1.5 text-petit text-ink-muted">
            {nodeCount} nodes, {edgeCount} edges
          </p>
          <p className="mt-0.5 text-micro text-ink-faint">
            Updated {timeAgo(project.updatedAt)}
          </p>
        </Link>

        <Button
          variant="ghost"
          size="sm"
          className="opacity-0 group-hover:opacity-100 transition-opacity !text-tiny !text-ink-muted"
          onClick={(e) => {
            e.preventDefault();
            onDelete(project.id);
          }}
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
